import { WebPlayer, updateDeviceCapabilities as updateDeviceCapabilitiesBase, getWebDeviceCapabilities, getDeviceCapabilities, WithStatsForNerdsWebRenderer, getWebAdapters, WebAdapterName, } from '@zattoo/playback-sdk';
const updateDeviceCapabilities = () => {
    updateDeviceCapabilitiesBase(getWebDeviceCapabilities());
};
export const createPlayer = async (options) => {
    updateDeviceCapabilities();
    const PlayerClass = WithStatsForNerdsWebRenderer(WebPlayer);
    const playerAdapterName = options.playerAdapter ?? WebAdapterName.Shaka;
    const PlayerAdapter = await getWebAdapters()[playerAdapterName]();
    const player = new PlayerClass(options, new PlayerAdapter.AdapterWithIma(options, getDeviceCapabilities));
    return Promise.resolve(player);
};
export { PlayerView, } from './player-view';
export { WebPlayer as Player };
export { updateDeviceCapabilities, getDeviceCapabilities, };
